function EventAnalysisService($http, $httpParamSerializer, AppSettings, CommonService) {
  'ngInject';

  const service = {};

  service.getPosition = function (width, height, code) {
    // width, height 가 각각 아래와 같을 때, x1 ~ y14 변수의 값이 변수 우측의 주석과 같음
    // width: 320
    // height: 244

    let rateObj = {
      x: null,
      y: null
    };
    let x1 = 0.0375;  // 12
    let x2 = 0.1031;  // 33
    let x3 = 0.2969;  // 95
    let x4 = 0.375;   // 120
    let x5 = 0.4688;  // 150
    let x6 = 0.0563;  // 18
    let x7 = 0.1781;  // 57
    let x8 = 0.2188;  // 70
    let x9 = 0.125;   // 40
    let x10 = 0.0844; // 27
    let x11 = 0.15;   // 48
    let y1 = 0.0492;  // 12
    let y2 = 0.123;   // 30
    let y3 = 0.1803;  // 44
    let y4 = 0.3033;  // 74
    let y5 = 0.3443;  // 84
    let y6 = 0.4180;  // 102
    let y7 = 0.4590;  // 112
    let y8 = 0.5;     // 122
    let y9 = 0.541;   // 132
    let y10 = 0.582;  // 142
    let y11 = 0.6557; // 160
    let y12 = 0.6967; // 170
    let y13 = 0.8197; // 200
    let y14 = 0.877;  // 214

    switch (code) {
      //코너킥 -start
      case 'A-CK-R':  // A면 코너킥 오른쪽
        rateObj = { x: x1, y: y1 };
        break;

      case 'A-CK-L':  // A면 코너킥 왼쪽
        rateObj = { x: x1, y: 1 - y1 };
        break;

      case 'B-CK-L':  // B면 코너킥 왼쪽
        rateObj = { x: 1 - x1, y: 1 - y1 };
        break;

      case 'B-CK-R':  // B면 코너킥 오른쪽
        rateObj = { x: 1 - x1, y: y1 };
        break;
      //코너킥 -end

      //오른쪽 -start
      case 'A-PA-CK-R':  // A면 페널티 에어리어 코너 부근 오른쪽
        rateObj = { x: x2, y: y2 };
        break;

      case 'A-AK-TL-R':  // A면 아크서클 터치라인 부근 오른쪽
        rateObj = { x: x3, y: y2 };
        break;

      case 'A-MF-TL-R':  // A면 미드필드 터치라인 부근 오른쪽
        rateObj = { x: x4, y: y2 };
        break;

      case 'A-HL-TL-R':  // A면 하프라인 터치라인 부근 오른쪽
        rateObj = { x: x5, y: y2 };
        break;

      case 'B-PA-CK-R':  // B면 페널티 에어리어 코너 부근 오른쪽
        rateObj = { x: 1 - x2, y: y14 };
        break;

      case 'B-AK-TL-R':  // B면 아크서클 터치라인 부근 오른쪽
        rateObj = { x: 1 - x3, y: y14 };
        break;

      case 'B-MF-TL-R':  // B면 미드필드 터치라인 부근 오른쪽
        rateObj = { x: 1 - x4, y: y14 };
        break;

      case 'B-HL-TL-R':  // B면 하프라인 터치라인 부근 오른쪽
        rateObj = { x: 1 - x5, y: y14 };
        break;

      case 'A-PA-OUT-EL-R':  // A면 페널티 에어리어 바깥쪽 엔드라인 부근 오른쪽
        rateObj = { x: x6, y: y3 };
        break;

      case 'A-PA-OUT-SD-R':  // A면 페널티 에어리어 바깥쪽 사이드 부근 오른쪽
        rateObj = { x: x7, y: y3 };
        break;

      case 'B-PA-OUT-EL-R':  // B면 페널티 에어리어 바깥쪽 엔드라인 부근 오른쪽
        rateObj = { x: 1 - x6, y: y13 };
        break;

      case 'B-PA-OUT-SD-R':  // B면 페널티 에어리어 바깥쪽 사이드 부근 오른쪽
        rateObj = { x: 1 - x7, y: y13 };
        break;

      case 'A-PA-IN-EL-R':  // A면 페널티 에어리어 안쪽 엔드라인 부근 오른쪽
        rateObj = { x: x6, y: y4 };
        break;

      case 'A-PA-OUT-FR-R':  // A면 페널티 에어리어 바깥쪽 정면 부근 오른쪽
        rateObj = { x: x8, y: y4 };
        break;

      case 'A-MF-R':  // A면 미드필드 부근 오른쪽
        rateObj = { x: x4, y: y4 };
        break;

      case 'B-PA-IN-EL-R':  // B면 페널티 에어리어 안쪽 엔드라인 부근 오른쪽
        rateObj = { x: 1 - x6, y: y12 };
        break;

      case 'B-PA-OUT-FR-R':  // B면 페널티 에어리어 바깥쪽 정면 부근 오른쪽
        rateObj = { x: 1 - x8, y: y12 };
        break;

      case 'B-MF-R':  // B면 미드필드 부근 오른쪽
        rateObj = { x: 1 - x4, y: y12 };
        break;

      case 'A-GA-OUT-FR-R':  // A면 골 에어리어 바깥쪽 정면 부근 오른쪽
        rateObj = { x: x9, y: y5 };
        break;

      case 'A-HL-R':  // A면 하프라인 오른쪽
        rateObj = { x: x5, y: y5 };
        break;

      case 'B-GA-OUT-FR-R':  // B면 골 에어리어 바깥쪽 정면 부근 오른쪽
        rateObj = { x: 1 - x9, y: y11 };
        break;

      case 'B-HL-R':  // B면 하프라인 오른쪽
        rateObj = { x: 1 - x5, y: y11 };
        break;

      case 'A-GA-IN-EL-R':  // A면 골 에어리어 안쪽 엔드라인 오른쪽
        rateObj = { x: x6, y: y6 };
        break;

      case 'A-GA-IN-R':  // A면 골 에어리어 안쪽 오른쪽
        rateObj = { x: x10, y: y6 };
        break;

      case 'A-PA-IN-FR-R':  // A면 페널티 에어리어 안쪽 정면 부근 오른쪽
        rateObj = { x: x7, y: y6 };
        break;

      case 'A-AK-R':  // A면 아크서클 부근 오른쪽
        rateObj = { x: x3, y: y6 };
        break;

      case 'B-GA-IN-EL-R':  // B면 골 에어리어 안쪽 엔드라인 오른쪽
        rateObj = { x: 1 - x6, y: y10 };
        break;

      case 'B-GA-IN-R':  // B면 골 에어리어 안쪽 오른쪽
        rateObj = { x: 1 - x10, y: y10 };
        break;

      case 'B-PA-IN-FR-R':  // B면 페널티 에어리어 안쪽 정면 부근 오른쪽
        rateObj = { x: 1 - x7, y: y10 };
        break;

      case 'B-AK-R':  // B면 아크서클 부근 오른쪽
        rateObj = { x: 1 - x3, y: y10 };
        break;

      case 'A-GA-IN-GK-R':  // A면 골 에어리어 안쪽 골킥 부근 오른쪽
        rateObj = { x: x6, y: y7 };
        break;

      case 'A-PK-R':  // A면 페널티킥 부근 오른쪽
        rateObj = { x: x11, y: y7 };
        break;

      case 'B-GA-IN-GK-R':  // B면 골 에어리어 안쪽 골킥 부근 오른쪽
        rateObj = { x: 1 - x6, y: y9 };
        break;

      case 'B-PK-R':  // B면 페널티킥 부근 오른쪽
        rateObj = { x: 1 - x11, y: y9 };
        break;

      case 'A-GA-IN-GK-C':  // A면 골 에어리어 안쪽 골킥 부근 가운데
        rateObj = { x: x6, y: y8 };
        break;

      case 'A-GA-IN-C':  // A면 골 에어리어 안쪽 가운데
        rateObj = { x: x10, y: y8 };
        break;

      case 'A-GA-OUT-FR-C':  // A면 골 에어리어 바깥쪽 정면 부근 가운데
        rateObj = { x: x9, y: y8 };
        break;

      case 'A-PK-C':  // A면 페널티킥 부근 가운데
        rateObj = { x: x11, y: y8 };
        break;

      case 'A-PA-IN-FR-C':  // A면 페널티 에어리어 안쪽 정면 부근 가운데
        rateObj = { x: x7, y: y8 };
        break;

      case 'A-PA-OUT-FR-C':  // A면 페널티 에어리어 바깥쪽 정면 부근 가운데
        rateObj = { x: x8, y: y8 };
        break;

      case 'A-AK-C':  // A면 아크서클 부근 가운데
        rateObj = { x: x3, y: y8 };
        break;

      case 'A-MF-C':  // A면 미드필드 부근 가운데
        rateObj = { x: x4, y: y8 };
        break;

      case 'A-HL-C':  // A면 하프라인 가운데
        rateObj = { x: x5, y: y8 };
        break;

      case 'B-GA-IN-GK-C':  // B면 골 에어리어 안쪽 골킥 부근 가운데
        rateObj = { x: 1 - x6, y: y8 };
        break;

      case 'B-GA-IN-C':  // B면 골 에어리어 안쪽 가운데
        rateObj = { x: 1 - x10, y: y8 };
        break;

      case 'B-GA-OUT-FR-C':  // B면 골 에어리어 바깥쪽 정면 부근 가운데
        rateObj = { x: 1 - x9, y: y8 };
        break;

      case 'B-PK-C':  // B면 페널티킥 부근 가운데
        rateObj = { x: 1 - x11, y: y8 };
        break;

      case 'B-PA-IN-FR-C':  // B면 페널티 에어리어 안쪽 정면 부근 가운데
        rateObj = { x: 1 - x7, y: y8 };
        break;

      case 'B-PA-OUT-FR-C':  // B면 페널티 에어리어 바깥쪽 정면 부근 가운데
        rateObj = { x: 1 - x8, y: y8 };
        break;

      case 'B-AK-C':  // B면 아크서클 부근 가운데
        rateObj = { x: 1 - x3, y: y8 };
        break;

      case 'B-MF-C':  // B면 미드필드 부근 가운데
        rateObj = { x: 1 - x4, y: y8 };
        break;

      case 'B-HL-C':  // B면 하프라인 가운데
        rateObj = { x: 1 - x5, y: y8 };
        break;

      case 'A-GA-IN-GK-L':  // A면 골 에어리어 안쪽 골킥 부근 왼쪽
        rateObj = { x: x6, y: y9 };
        break;

      case 'A-PK-L':  // A면 페널티킥 부근 왼쪽
        rateObj = { x: x11, y: y9 };
        break;

      case 'B-GA-IN-GK-L':  // B면 골 에어리어 안쪽 골킥 부근 왼쪽
        rateObj = { x: 1 - x6, y: y7 };
        break;

      case 'B-PK-L':  // B면 페널티킥 부근 왼쪽
        rateObj = { x: 1 - x11, y: y7 };
        break;

      case 'A-GA-IN-EL-L':  // A면 골 에어리어 안쪽 엔드라인 왼쪽
        rateObj = { x: x6, y: y10 };
        break;

      case 'A-GA-IN-L':  // A면 골 에어리어 안쪽 왼쪽
        rateObj = { x: x10, y: y10 };
        break;

      case 'A-PA-IN-FR-L':  // A면 페널티 에어리어 안쪽 정면 부근 왼쪽
        rateObj = { x: x7, y: y10 };
        break;

      case 'A-AK-L':  // A면 아크서클 부근 왼쪽
        rateObj = { x: x3, y: y10 };
        break;

      case 'B-GA-IN-EL-L':  // B면 골 에어리어 안쪽 엔드라인 왼쪽
        rateObj = { x: 1 - x6, y: y6 };
        break;

      case 'B-GA-IN-L':  // B면 골 에어리어 안쪽 왼쪽
        rateObj = { x: 1 - x10, y: y6 };
        break;

      case 'B-PA-IN-FR-L':  // B면 페널티 에어리어 안쪽 정면 부근 왼쪽
        rateObj = { x: 1 - x7, y: y6 };
        break;

      case 'B-AK-L':  // B면 아크서클 부근 왼쪽
        rateObj = { x: 1 - x3, y: y6 };
        break;

      case 'A-GA-OUT-FR-L':  // A면 골 에어리어 바깥쪽 정면 부근 왼쪽
        rateObj = { x: x9, y: y11 };
        break;

      case 'A-HL-L':  // A면 하프라인 왼쪽
        rateObj = { x: x5, y: y11 };
        break;

      case 'B-GA-OUT-FR-L':  // B면 골 에어리어 바깥쪽 정면 부근 왼쪽
        rateObj = { x: 1 - x9, y: y5 };
        break;

      case 'B-HL-L':  // B면 하프라인 왼쪽
        rateObj = { x: 1 - x5, y: y5 };
        break;

      case 'A-PA-IN-EL-L':  // A면 페널티 에어리어 안쪽 엔드라인 부근 왼쪽
        rateObj = { x: x6, y: y12 };
        break;

      case 'A-PA-OUT-FR-L':  // A면 페널티 에어리어 바깥쪽 정면 부근 왼쪽
        rateObj = { x: x8, y: y12 };
        break;

      case 'A-MF-L':  // A면 미드필드 부근 왼쪽
        rateObj = { x: x4, y: y12 };
        break;

      case 'B-PA-IN-EL-L':  // B면 페널티 에어리어 안쪽 엔드라인 부근 왼쪽
        rateObj = { x: 1 - x6, y: y4 };
        break;

      case 'B-PA-OUT-FR-L':  // B면 페널티 에어리어 바깥쪽 정면 부근 왼쪽
        rateObj = { x: 1 - x8, y: y4 };
        break;

      case 'B-MF-L':  // B면 미드필드 부근 왼쪽
        rateObj = { x: 1 - x4, y: y4 };
        break;

      case 'A-PA-OUT-EL-L':  // A면 페널티 에어리어 바깥쪽 엔드라인 부근 왼쪽
        rateObj = { x: x6, y: y13 };
        break;

      case 'A-PA-OUT-SD-L':  // A면 페널티 에어리어 바깥쪽 사이드 부근 왼쪽
        rateObj = { x: x7, y: y13 };
        break;

      case 'B-PA-OUT-EL-L':  // B면 페널티 에어리어 바깥쪽 엔드라인 부근 왼쪽
        rateObj = { x: 1 - x6, y: y3 };
        break;

      case 'B-PA-OUT-SD-L':  // B면 페널티 에어리어 바깥쪽 사이드 부근 왼쪽
        rateObj = { x: 1 - x7, y: y3 };
        break;

      case 'A-PA-CK-L':  // A면 페널티 에어리어 코너 부근 왼쪽
        rateObj = { x: x2, y: y14 };
        break;

      case 'A-AK-TL-L':  // A면 아크서클 터치라인 부근 왼쪽
        rateObj = { x: x3, y: y14 };
        break;

      case 'A-MF-TL-L':  // A면 미드필드 터치라인 부근 왼쪽
        rateObj = { x: x4, y: y14 };
        break;

      case 'A-HL-TL-L':  // A면 하프라인 터치라인 부근 왼쪽
        rateObj = { x: x5, y: y14 };
        break;

      case 'B-PA-CK-L':  // B면 페널티 에어리어 코너 부근 왼쪽 
        rateObj = { x: 1 - x2, y: y2 };
        break;

      case 'B-AK-TL-L':  // B면 아크서클 터치라인 부근 왼쪽
        rateObj = { x: 1 - x3, y: y2 };
        break;

      case 'B-MF-TL-L':  // B면 미드필드 터치라인 부근 왼쪽
        rateObj = { x: 1 - x4, y: y2 };
        break;

      case 'B-HL-TL-L':  // B면 하프라인 터치라인 부근 왼쪽
        rateObj = { x: 1 - x5, y: y2 };
        break;
    }

    return {
      x: parseInt(width * rateObj.x, 10),
      y: parseInt(height * rateObj.y, 10)
    };
  };

  // Get HomeTeam time_location 
  service.getTeam = function (params) {
    let url;
    url = AppSettings.apiUrl.restRoot + 'mock/main/timeline/team/home_team'; // home_team 경기시간 1분간격 barchart data
    url = AppSettings.apiUrl.restRoot + 'mock/main/timeline/player/111'; // player 111 1분간격 barchart data
    url = AppSettings.apiUrl.restRoot + 'mock/main/location/team/home_team'; // home_team 경기시간 전체 data
    url = AppSettings.apiUrl.restRoot + 'mock/main/location/team/away_team'; // away_team 경기시간 전체 data
    url = AppSettings.apiUrl.restRoot + 'mock/main/location/team/home_team/35'; // home_team 의 35분 data
    url = AppSettings.apiUrl.restRoot + 'mock/main/location/player/111/'; // player 111 전체 data
    url = AppSettings.apiUrl.restRoot + 'mock/main/location/player/111/35'; // player 111 의 35분 data 

    return CommonService.post(url, params);
  }

  service.getHomeTeamTimeline = function(params) {
    const url = '/mock/main/timeline/team/home_team'; // home_team 경기시간 1분간격 barchart data
    return CommonService.get(url, params);
  }

  service.getAwayTeamTimeline = function(params) {
    const url = '/mock/main/timeline/team/away_team'; // home_team 경기시간 1분간격 barchart data
    return CommonService.get(url, params);
  }

  //
  service.getTimeLocation = function(params) {
    const url = '/mock/main/timelocation/teamOrPlayerId'; // home_team 경기시간 1분간격 barchart data
    return CommonService.get(url, params);
  }
  return service;
}

export default {
  name: 'EventAnalysisService',
  fn: EventAnalysisService
};
